module.exports = __webpack_public_path__ + "static/img/CgoRC2RCSFCAfBLWAAFkcw9zhcw945.08e63da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRC2RCSFCAfBLWAAFkcw9zhcw945.jpg
// module id = 8rP2
// module chunks = 73